export const on_product_name = ({
	product_name,
	product_category
}: {
	product_name: string;
	product_category: string;
}): void => {
	window.gtm?.({ event: 'product_name', product_name, product_category });
};

export const on_store_zipcode = ({
	store_zip
}: {
	store_zip: number;
}): void => {
	window.gtm?.({ event: 'store_location', store_zip });
};
export const on_product_add_favorite = ({
	product_favorite_name
}: {
	product_favorite_name: string;
}): void => {
	window.gtm?.({ event: 'product_add_favorite', product_favorite_name });
};
export const on_product_add_cart = ({
	product_cart_name
}: {
	product_cart_name: string;
}): void => {
	window.gtm?.({ event: 'product_add_cart', product_cart_name });
};
export const on_checkout_products = ({
	checkout_products_name,
	user_type
}: {
	checkout_products_name: string;
	user_type: 'guest' | 'logged_in';
}): void => {
	window.gtm?.({
		event: 'checkout_products',
		checkout_products_name,
		user_type
	});
};
export const on_attempted_checkout = ({
	checkout_products_name,
	user_type
}: {
	checkout_products_name: string;
	user_type: 'guest' | 'logged_in';
}): void => {
	window.gtm?.({
		event: 'attempted_checkout',
		checkout_products_name,
		user_type
	});
};
export const on_find_drink = ({
	find_drink_name
}: {
	find_drink_name: string;
}): void => {
	window.gtm?.({ event: 'find_drink', find_drink_name });
};
export const on_sign_up = ({ sign_up }: { sign_up: string }): void => {
	window.gtm?.({ event: 'sign_up', sign_up });
};
